'use strict';
var isArray = require('../utils/is-array'),
    assign = require('../utils/assign'),
    getKeys = require('../utils/get-keys');

/**
 *
 * @returns {*}
 */
module.exports = function merge() {
    var object = arguments[0],
        source = arguments[1],
        sourceIndex = 1,
        index,
        keys;

    while (source) {
        keys = getKeys(source);
        index = keys.length;

        while (index--) {
            if (isArray(object[keys[index]]) && isArray(source[keys[index]])) {
                object[keys[index]] = object[keys[index]].concat(source[keys[index]]);
            } else if (typeof object[keys[index]] === 'object' && typeof source[keys[index]] === 'object') {
                object[keys[index]] = assign({}, object[keys[index]], source[keys[index]]);
            } else {
                object[keys[index]] = source[keys[index]];
            }
        }

        sourceIndex++;
        source = arguments[sourceIndex];
    }

    return object;
};
